import { Component, HostListener, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  public currentModule: any;
  public loginData: any;

  public deviceType: any = 'mobile'; // mobile/tablet/desktop
  public showSideMenu: string = 'none'; // Closed by default (none/block)

  constructor(
    private _router: Router,
    private _renderer2: Renderer2,
    private _activatedRoute: ActivatedRoute,
    private _utilService: UtilService,
  ) {
    this.currentModule = this._activatedRoute.snapshot.data.module;
    this.deviceType = this._utilService.getDeviceType();
  }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    if (this.currentModule == 'retailer') { // Retailer login
      this.loginData = await this._utilService.getStorageData('R_LOGIN');
    } else if (this.currentModule == 'cpg') { // CPG login
      this.loginData = await this._utilService.getStorageData('C_LOGIN');
    } else if (this.currentModule == 'distributor') { // Distributor login
      this.loginData = await this._utilService.getStorageData('D_LOGIN');
    } else if (this.currentModule == 'admin') { // Admin login
      this.loginData = await this._utilService.getStorageData('A_LOGIN');
    }

    if (!this.loginData) { // Login datais missing
      this._router.navigate(['/retailer']);
    } else {
      // Set side menu style
      if (this.deviceType == 'desktop') { // Desktop - Open by default
        this.showSideMenu = 'block';
      } else { // Mobile/Tablet - Closed by default
        this.showSideMenu = 'none';
      }
    }
  }

  // Toggle side menu
  async toggleSideMenu() {
    if (this.showSideMenu === 'none') {
      this.showSideMenu = 'block';
    } else {
      this.showSideMenu = 'none';
    }

    /*if (this.deviceType == 'desktop') { // Desktop - Save user selection in storage
      let responseSetSideMenu = await this._utilService.setStorageData('SIDE_MENU', { showSideMenu: this.showSideMenu });
    } else { // Mobile/Tablet
    }*/
  }

  // Menu click
  /*menuClick(menu: any) {
    this._router.navigate([menu.route]); // Navigate to link
  }*/

  // Change password click
  onChangePassword()  {
    if (this.currentModule == 'retailer') { // Retailer login
      this._router.navigate(['/retailer/change-password']);
    } else if (this.currentModule == 'cpg') { // CPG login
      this._router.navigate(['/cpg/change-password']);
    } else if (this.currentModule == 'distributor') { // Distributor login
      this._router.navigate(['/distributor/change-password']);
    } else if (this.currentModule == 'admin') { // Admin login
    }
  }

  // Logout click
  onLogout() {
    if (this.currentModule == 'retailer') { // Retailer login
      this._utilService.retailerLogout();
    } else if (this.currentModule == 'cpg') { // CPG login
      this._utilService.cpgLogout();
    } else if (this.currentModule == 'distributor') { // Distributor login
      this._utilService.distributorLogout();
    } else if (this.currentModule == 'admin') { // Admin login
      this._utilService.adminLogout();
    }
  }



}
